import { Grid } from '@mui/material';
import React from 'react';

import { TabPanelProps } from './types';

export default function TabPanel(props: TabPanelProps) {
    const {
        className,
        children,
        value,
        index,
        ...other
    } = props;

    return (
        <>
            {value === index &&
                <Grid
                    aria-labelledby={`scrollable-auto-tab-${index}`}
                    className={className}
                    container
                    direction='column'
                    hidden={value !== index}
                    id={`scrollable-auto-tabpanel-${index}`}
                    role='tabpanel'
                    spacing={0}
                    wrap='nowrap'
                    {...other}
                >
                    <>{children}</>
                </Grid>}
        </>
    );
}